import React, { useEffect, useMemo } from 'react';
import { Button, Form } from 'react-bootstrap';
import { ASSISTENCIA_IMAGE_ACCEPT } from '../../../Assistencias/assistenciasFormShared';

const ImageUploadField = ({
  label,
  fieldKey,
  existingUrl = '',
  file = null,
  disabled = false,
  onFileSelect,
  onClear,
}) => {
  const previewUrl = useMemo(() => {
    if (file instanceof File) {
      return URL.createObjectURL(file);
    }
    return existingUrl || '';
  }, [file, existingUrl]);

  useEffect(() => {
    if (!(file instanceof File) || !previewUrl.startsWith('blob:')) return undefined;
    return () => URL.revokeObjectURL(previewUrl);
  }, [file, previewUrl]);

  const handleChange = (event) => {
    const selected = event.target.files?.[0];
    if (selected) {
      onFileSelect(fieldKey, selected);
    }
    event.target.value = '';
  };

  return (
    <Form.Group className="mb-2">
      <Form.Label>{label}</Form.Label>
      <div
        className="border rounded p-2 d-flex flex-column align-items-center"
        style={{ minHeight: 140, background: 'var(--card-bg, #f8f9fa)' }}
      >
        {previewUrl ? (
          <img
            src={previewUrl}
            alt={label}
            style={{ maxHeight: 100, maxWidth: '100%', objectFit: 'contain' }}
            className="mb-2"
          />
        ) : (
          <span className="text-muted small mb-2">Nenhuma imagem selecionada</span>
        )}
        <div className="d-flex flex-wrap gap-2 justify-content-center">
          <Form.Control
            type="file"
            accept={ASSISTENCIA_IMAGE_ACCEPT}
            onChange={handleChange}
            disabled={disabled}
            size="sm"
            style={{ maxWidth: 220 }}
          />
          {(file || existingUrl) && (
            <Button
              type="button"
              variant="outline-secondary"
              size="sm"
              disabled={disabled}
              onClick={() => onClear(fieldKey)}
            >
              Remover
            </Button>
          )}
        </div>
        <Form.Text className="text-muted text-center mt-2">
          PNG, JPG ou WEBP — máximo 2MB
        </Form.Text>
      </div>
    </Form.Group>
  );
};

export default ImageUploadField;
